import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CloseIcon } from '@calendly/ui/components/icons'
import { Link } from '@calendly/ui/components/link'
import { Loader } from '@calendly/ui/components/loader'
import { Modal } from '@calendly/ui/components/modal'
import { Body, Footer, Title } from '@calendly/ui/components/popup'
import { BodyText } from '@calendly/ui/components/typography'
import { ViewSwitcher } from '@calendly/ui/components/view-switcher'
import { useState } from 'react'

import { useFetchUsersVideoConferencingIntegrationsReport } from 'features/reporting'

import { VIEWS } from './constants'
import { getSwitcherOptions, getUsersIntegrationsBreakdown } from './helpers'
import { Header, ModalContainer, ViewContainer, WideFooterButton } from './styles'
import { UsersList } from './users_list'

const IntegrationsLinkComponent = (props) => (
  <Link
    {...props}
    href="/integrations"
    target="_blank"
    rel="noopener noreferrer"
  />
)

const getDescription = ({ view, users }) => {
  switch (view) {
    case VIEWS.notConnected:
      if (users.length > 0) {
        return HtmlParser(
          I18n.t('publisher.admin.dashboard.section.users.modal.video_conferencing.not_connected.description'),
          { IntegrationsLinkComponent }
        )
      }

      return I18n.t('publisher.admin.dashboard.section.users.modal.video_conferencing.not_connected.empty')

    case VIEWS.hasErrors:
      if (users.length > 0) {
        return HtmlParser(
          I18n.t('publisher.admin.dashboard.section.users.modal.video_conferencing.error.description'),
          { IntegrationsLinkComponent }
        )
      }

      return I18n.t('publisher.admin.dashboard.section.users.modal.video_conferencing.error.empty')

    default:
      return ''
  }
}

export const ConnectedVideoConferencingModal = ({ isOpen, onClose, notConnectedCount, errorCount }) => {
  const [view, setView] = useState(VIEWS.notConnected)
  const usersCalendarIntegrations = useFetchUsersVideoConferencingIntegrationsReport({ group_by: 'user', status: view, skip: !isOpen })

  const { users, isFetching } = getUsersIntegrationsBreakdown(usersCalendarIntegrations)
  const switcherOptions = getSwitcherOptions({ notConnectedCount, errorCount, view })

  const handleClose = () => {
    onClose()
    setView(VIEWS.notConnected)
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalContainer>
        <Header>
          <Title>{I18n.t('publisher.admin.dashboard.section.users.modal.video_conferencing.title')}</Title>
          <IconButton title={I18n.t('publisher.action.close')} onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Header>
        <Body>
          <ViewSwitcher
            name="connected-video-conferencing-view-switcher"
            options={switcherOptions}
            onChange={(e) => setView(e.target.value)}
            value={view}
          />

          <ViewContainer>
            {isFetching ? <Loader data-testid="loader" /> : (
              <>
                <BodyText>{getDescription({ view, users })}</BodyText>
                <UsersList users={users} showVideoConferencingNames={view === VIEWS.hasErrors} />
              </>
            )}
          </ViewContainer>
        </Body>
        <Footer>
          <WideFooterButton
            onClick={handleClose}
            decoration="secondary-outline"
          >
            {I18n.t('publisher.action.okay')}
          </WideFooterButton>
        </Footer>
      </ModalContainer>
    </Modal>
  )
}
